import { Snackbar } from '@material-ui/core';
import * as _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';

class ErrorBoundary extends React.Component<any, any> {
  public state = {
    hasError: false,
    lastError: null,
  };

  public componentDidUpdate() {
    if (this.props.error && this.state.lastError !== this.props.error) {
      this.setState({ hasError: true, lastError: this.props.error });
    }
  }

  public handleClose() {
    return () => {
      this.setState({ hasError: false });
    };
  }

  /*
  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Display fallback UI
    this.setState({ hasError: true });
    console.error(error);
  } */

  public render() {
    if (this.state.hasError) {
      return (
        <>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            open={this.state.hasError}
            onClose={this.handleClose()}
            autoHideDuration={6000}
            message={<span id="message-id">{this.props.error}</span>}
          />
          {this.props.children}
        </>
      );
    }
    return this.props.children;
  }
}

const mapStateToProps = (state: any) => {
  const firstError = _.find(state, subState => subState.error);
  return {
    error: firstError ? firstError.error : null,
  };
};

export default connect(mapStateToProps)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/hoc/ErrorBoundary.tsx